/**
 * @generated SignedSource<<f568eda0207ba33d3b8b143ea7b75849>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamAccessType = "full" | "partial" | "shared";
export type UserAccessRowUnsharingMutation$variables = {
  id: string;
  userId: string;
};
export type UserAccessRowUnsharingMutation$data = {
  readonly noteStreamUnshare: {
    readonly noteStream: {
      readonly id: string;
      readonly index: number | null;
      readonly notes: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly noteuserSet: ReadonlyArray<{
              readonly id: string;
            }>;
          } | null;
        } | null>;
      } | null;
      readonly notestreamusers: ReadonlyArray<{
        readonly accessType: StreamAccessType;
        readonly id: string;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isActive: boolean;
          readonly isConfigured: boolean;
          readonly isGuest: boolean;
          readonly lastName: string;
        };
      }>;
      readonly userCount: number;
    };
    readonly noteStreamId: string;
    readonly updatedStreams: ReadonlyArray<{
      readonly id: string;
      readonly index: number | null;
    } | null>;
  } | null;
};
export type UserAccessRowUnsharingMutation = {
  response: UserAccessRowUnsharingMutation$data;
  variables: UserAccessRowUnsharingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "NoteStreamUnshare",
    "kind": "LinkedField",
    "name": "noteStreamUnshare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noteStreamId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "updatedStreams",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamUser",
            "kind": "LinkedField",
            "name": "notestreamusers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isConfigured",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGuest",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              }
            ],
            "concreteType": "NotesConnection",
            "kind": "LinkedField",
            "name": "notes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteUser",
                        "kind": "LinkedField",
                        "name": "noteuserSet",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "notes(first:3)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAccessRowUnsharingMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAccessRowUnsharingMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9f351e2a1a0c35e13f69083d94cb1c96",
    "id": null,
    "metadata": {},
    "name": "UserAccessRowUnsharingMutation",
    "operationKind": "mutation",
    "text": "mutation UserAccessRowUnsharingMutation(\n  $id: ID!\n  $userId: ID!\n) {\n  noteStreamUnshare(id: $id, userId: $userId) {\n    noteStreamId\n    updatedStreams {\n      id\n      index\n    }\n    noteStream {\n      id\n      index\n      userCount\n      notestreamusers {\n        id\n        accessType\n        user {\n          id\n          email\n          image\n          fullName\n          lastName\n          firstName\n          isActive\n          isConfigured\n          isGuest\n        }\n      }\n      notes(first: 3) {\n        edges {\n          node {\n            id\n            noteuserSet {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7307ee0da31cc4d3dc0571de05e9c0ea";

export default node;
